import axios from "axios";
export default {
    state:{
        allitems:[],
        productMostSelledItem:[]
    },
    mutations:{
        setProductos(state,items){
            state.allitems=items
        },
        setProductMostSelledItem(state,data){
            state.productMostSelledItem = data;
        }
    },
    actions:{
        async setProductos({commit,rootState,getters}){           
           await axios.get(`${rootState.urlapi}/articulos`,getters.getTokenUser).then(response=>{
                    commit('setProductos',response.data)  
              }).catch(err=>{
                console.error(err)
                commit('setProductos',[])  
              });
        },
        async setExistencias({commit,rootState,getters},id){           
            await axios.get(`${rootState.urlapi}/articulostock/sucursal/`+id,getters.getTokenUser).then(response=>{
                
                     commit('setProductMostSelledItem',response.data)  
               }).catch(err=>{
                 console.error(err)
                 commit('setProductMostSelledItem',[])  
               });
         },
        async setProductMostSelledItem({commit,rootState,getters}){
            await axios.get(`${rootState.urlapi}/articulos/mostselled`,getters.getTokenUser).then(response=>{
                commit('setProductMostSelledItem',response.data)  
             }).catch(err=>{console.error(err)});
        },
        async decrementStock({rootState,getters},params){
           return  await axios.put(`${rootState.urlapi}/articulos/disminuirStock/${params.idfactura}/${params.idestablecimiento}`,{},getters.getTokenUser)
        },
        async updateProducto({rootState,getters},item){
          return   await axios.put(`${rootState.urlapi}/articulos/${item.idarticulo}`,item,getters.getTokenUser)
        },
        async postExistencias({rootState,getters},data){
            return   await axios.post(`${rootState.urlapi}/articulostock`,[data],getters.getTokenUser)
        },
        async patchExistencias({rootState,getters},data){
            return   await axios.patch(`${rootState.urlapi}/articulostock/`+data.articulo,data,getters.getTokenUser)
        },
        async deleteExistencias({rootState,getters},id){
            return   await axios.delete(`${rootState.urlapi}/articulostock/`+id,getters.getTokenUser)
        },

    },
    getters:{
        getAllProductos(state){
            //Si existe un registro retornamos el arreglo
            if(state.allitems[0])return state.allitems
            //Sino existen registros retornamos un array vacio
            return []
        },
        getProductosActivos(state){
            return state.productMostSelledItem
        }
        
    }
}